import { Alert } from '@mui/material';

const StatusAlert = ({ status }) => {
    const getAlert = (variant, severity) => (
        <Alert variant={variant} severity={severity}>
            {status.message}
        </Alert>
    );

    return (
        <>
            {status?.type === 'success' && getAlert('filled', 'success')}
            {status?.type === 'error' && getAlert('filled', 'error')}
        </>
    );
};

export default StatusAlert;
